module.exports = __webpack_public_path__ + "public/media/1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/partners/1.jpg
// module id = ./images/partners/1.jpg
// module chunks = 0